import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { ProgressBarSuspenseFallback } from '@vivaldis/web-ui'
import { lazyOrReloadPage } from '../../utils/lazyOrReloadPage'

const AddEmployeeCertificate = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "AddEmployeeCertificate" */ './screens/AddEmployeeCertificate'
    )
)

const EditEmployeeGeneralInformation = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "EditEmployeeGeneralInformation" */ './screens/EditEmployeeGeneralInformation'
    )
)

const EditEmployeePersonalInformation = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "EditEmployeePersonalInformation" */ './screens/EditEmployeePersonalInformation'
    )
)

const EditEmployeeWageProfile = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "EditEmployeeWageProfile" */ './screens/EditEmployeeWageProfile'
    )
)

const EditEmployeeCertificate = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "EditEmployeeCertificate" */ './screens/EditEmployeeCertificate'
    )
)
const ViewEmployeeProfile = lazyOrReloadPage(
  () =>
    import(
      /* webpackChunkName: "ViewEmployeeProfile" */ './screens/ViewEmployeeProfile'
    )
)

export const EmployeeRoutes = () => (
  <Suspense fallback={ProgressBarSuspenseFallback}>
    <Routes>
      <Route
        path=":employeeId/add-employee-certificate"
        element={<AddEmployeeCertificate />}
      />
      <Route
        path=":employeeId/edit-employee-certificate/:certificateId"
        element={<EditEmployeeCertificate />}
      />
      <Route
        path=":employeeId/edit-employee-general-information"
        element={<EditEmployeeGeneralInformation />}
      />
      <Route
        path=":employeeId/edit-employee-personal-information"
        element={<EditEmployeePersonalInformation />}
      />
      <Route
        path=":employeeId/edit-employee-wage-profile"
        element={<EditEmployeeWageProfile />}
      />
      <Route
        path=":employeeId/view-employee-profile"
        element={<ViewEmployeeProfile />}
      />
    </Routes>
  </Suspense>
)
